// 模組07 訊息功能 — 通知規則的示範情境時間軸(9月交付 ticket 11)。
//
// 每筆情境=「某條規則正在盯的一件事」:條件何時成立(相對現在)、到期日、
// 何時恢復。排程器(mock/notifyScheduler.js)拿情境+規則餵進升級判定純函式,
// 把「該發到第幾階」實體化成通知 feed 的列。
//
// 文案全部出自 MSG 字典(msgKey 標明出處),變數以示範值代入 —— 不自創文案。
// closeBody 是該類的結案訊息(constants/notifyRules.js 的 NOTIFY_STOP_CONDITIONS)。
const DAY = 86400000;
const MIN = 60000;

export const notifyScheduleScenarios = [
  {
    // 資料未填(規則1):16 天前發現欄位未填 → 已滿 2 次,最新一則升第二階
    ruleId: 1,
    key: "hw-0001",
    context: (now) => ({ startAt: now - 16 * DAY }),
    source: "資產管理",
    type: "資料未填",
    actionLabel: "前往資產",
    msgKey: "MSG-0C-01",
    body: "硬體「核心服務主機」（HW-0001）尚有 3 個管理欄位未填寫：保固到期日、廠牌型號、所在位置。請於 2026/09/15 前補齊，以免影響報表統計與稽核查核。",
    closeMsgKey: "MSG-0C-03",
    closeBody: "硬體「核心服務主機」的未填欄位已於 2026/08/30 補齊，本項提醒已停止發送。",
  },
  {
    // 資料未填(規則1)之二:另一筆昨天補齊了 → 停止續發並發結案訊息(MSG-0C-03)
    ruleId: 1,
    key: "sw-0007",
    context: (now) => ({ startAt: now - 9 * DAY, resolvedAt: now - 1 * DAY }),
    source: "資產管理",
    type: "資料未填",
    actionLabel: "前往資產",
    msgKey: "MSG-0C-01",
    body: "軟體「防毒中控台」（SW-0007）尚有 1 個管理欄位未填寫：營運環境。請於 2026/09/10 前補齊，以免影響報表統計與稽核查核。",
    closeMsgKey: "MSG-0C-03",
    closeBody: "軟體「防毒中控台」的未填欄位已於 2026/08/29 補齊，本項提醒已停止發送。",
  },
  {
    // 合約/專案到期(規則2):合約 30 天後到期 → 今天正好是「前 30 天」提醒點
    ruleId: 2,
    key: "contract-2026",
    context: (now) => ({ startAt: now - 100 * DAY, dueAt: now + 30 * DAY }),
    source: "營運資訊",
    type: "合約到期",
    actionLabel: "前往合約",
    msgKey: "MSG-04-01",
    body: "合約「機房維運服務合約 2026」將於 30 天後（2026/09/29）到期，請評估續約或結案作業。",
  },
  {
    // 審核催辦(規則5):審核單停留 10 天 → 第 3/6/9 天催辦,逾 7 天升第二階
    // (舊票 14 備註寫「MSG-0A-03 逾期」,但 MSG 字典的 0A-03 是「中間關卡核准」——
    //  逾期語意由二階升級包裹版式承擔,不發明新文案)
    ruleId: 5,
    key: "rq-20260822-004",
    context: (now) => ({ startAt: now - 10 * DAY }),
    source: "審核訊息",
    type: "審核",
    docNo: "RQ-20260822-004",
    actionLabel: "前往審核",
    msgKey: "MSG-0A-07",
    body: "RQ-20260822-004｜使用者資訊－異動 已進入您的審核關卡，請儘速處理。",
  },
  {
    // 連線/系統告警(規則6):45 分鐘前觸發、剛剛恢復 → 升到二階後結案,發恢復訊息
    ruleId: 6,
    key: "cpu-host01",
    context: (now) => ({ startAt: now - 50 * MIN, resolvedAt: now - 5 * MIN }),
    source: "監控派工",
    type: "告警",
    actionLabel: "前往資產",
    msgKey: "MSG-06-06",
    body: "系統告警：「核心服務主機」CPU 使用率 92% 已超過門檻 80%，持續 5 分鐘以上，請儘速確認。",
    closeMsgKey: "MSG-06-10",
    closeBody: "系統告警已解除：「核心服務主機」已於 10:32 恢復正常（異常持續 45 分鐘）。",
  },
  {
    // 版本更新(規則8):40 天前發現新版 → 每 30 天續發;
    // 也是「暫停→回收/恢復→再產生」測試的操作對象
    ruleId: 8,
    key: "nginx-upgrade",
    context: (now) => ({ startAt: now - 40 * DAY }),
    source: "資產管理",
    type: "版本更新",
    actionLabel: "前往資產",
    msgKey: "MSG-05-19",
    body: "軟體更新提醒：「Nginx」有新版本 1.27.1 可用（現行 1.25.3），且含未修補 CVE 修正，請安排更新。",
  },
];
